export default __webpack_public_path__ + "static/media/work_big.31404eb8.png";